import pagesRoutesList from './Pages/pagesRoutesList';
import projectRoutesList from './Project/projectRoutesList';

const routesList = [...pagesRoutesList, ...projectRoutesList];

export default routesList;
